import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Box } from '@sorare/core/src/atoms/icons/Box';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelS } from '@sorare/core/src/atoms/typography';

const Wrapper = styled(Horizontal).attrs({ gap: 0.5, center: true })`
  padding: 2px var(--unit);
  background: var(--c-surface-success);
  border-radius: var(--double-unit);
`;
const Label = styled(LabelS).attrs({ bold: true })`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--unit);

  background: linear-gradient(
    323deg,
    rgba(var(--c-rgb-rivals-reputation), 0.8) -3.1%,
    rgba(var(--c-rgb-rivals-win), 1) 52.7%
  );

  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const RewardBoostApplied = () => {
  return (
    <Wrapper>
      <Box gradient="green" size={1.5} />
      <Label>
        <FormattedMessage
          id="FixtureOverview.rewardBoostApplied"
          defaultMessage="Reward boost applied"
        />
      </Label>
    </Wrapper>
  );
};
